import { HttpInterceptor } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Platform } from '@ionic/angular';
import {
  AngularAuthInterceptor,
  THDSAngularAuthService,
} from '@thds/auth/angular';

@Injectable({
  providedIn: 'root',
})
export class IonicAuthInterceptor
  extends AngularAuthInterceptor
  implements HttpInterceptor
{
  constructor(
    injector: Injector,
    private platform: Platform,
  ) {
    super(injector);
  }

  protected override async getService() {
    await this.platform.ready();
    this._authService = this.injector.get(THDSAngularAuthService);
  }
}
